import React from 'react';
import { Facebook, Twitter, Linkedin, Instagram, Mail, Phone, MapPin } from 'lucide-react';
import Logo from './Logo';
import { companyInfo } from '../mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'Home', id: 'home' },
    { name: 'About Us', id: 'about' },
    { name: 'Services', id: 'services' },
    { name: 'Projects', id: 'projects' }
  ];

  const services = [
    'Residential Construction',
    'Commercial Construction',
    'Infrastructure Projects',
    'Interior Design & Fit-outs'
  ];

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-[#214979] via-[#0a1a6b] to-[#214979] text-gray-300">
      {/* Main Footer Content */}
      <div className="container mx-auto px-4 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <Logo inverted={true} className="mb-4" />
            <p className="text-gray-300 mb-6 leading-relaxed">
              Building tomorrow's infrastructure today. Leading construction company in Ahmedabad with 15+ years of excellence.
            </p>
            <div className="flex gap-3">
              <a 
                href="#" 
                className="w-10 h-10 bg-[#c0932a]/20 hover:bg-[#c0932a] text-[#c0932a] hover:text-white rounded-full flex items-center justify-center transition-all duration-300"
              >
                <Facebook size={18} />
              </a>
              <a 
                href="#" 
                className="w-10 h-10 bg-[#c0932a]/20 hover:bg-[#c0932a] text-[#c0932a] hover:text-white rounded-full flex items-center justify-center transition-all duration-300"
              >
                <Twitter size={18} />
              </a>
              <a 
                href="#" 
                className="w-10 h-10 bg-[#c0932a]/20 hover:bg-[#c0932a] text-[#c0932a] hover:text-white rounded-full flex items-center justify-center transition-all duration-300"
              >
                <Linkedin size={18} />
              </a>
              <a 
                href="#" 
                className="w-10 h-10 bg-[#c0932a]/20 hover:bg-[#c0932a] text-[#c0932a] hover:text-white rounded-full flex items-center justify-center transition-all duration-300"
              >
                <Instagram size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white text-lg font-bold mb-4">Quick Links</h3>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.id}>
                  <button
                    onClick={() => scrollToSection(link.id)}
                    className="text-gray-400 hover:text-primary transition-colors"
                  >
                    {link.name}
                  </button>
                </li>
              ))}
              <li>
                <button
                  onClick={() => scrollToSection('team')}
                  className="text-gray-400 hover:text-primary transition-colors"
                >
                  Our Team
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('careers')}
                  className="text-gray-400 hover:text-primary transition-colors"
                >
                  Careers
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white text-lg font-bold mb-4">Our Services</h3>
            <ul className="space-y-3">
              {services.map((service, index) => (
                <li key={`footer-service-${index}-${service.slice(0, 10)}`}>
                  <button
                    onClick={() => scrollToSection('services')}
                    className="text-gray-300 hover:text-white transition-colors text-left"
                  >
                    {service}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white text-lg font-bold mb-4">Contact Info</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="w-10 h-10 bg-[#c0932a] rounded-full flex items-center justify-center flex-shrink-0">
                  <MapPin className="text-white" size={20} />
                </div>
                <span className="text-gray-300 text-sm leading-relaxed">
                  {companyInfo.address}
                </span>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-10 h-10 bg-[#c0932a] rounded-full flex items-center justify-center flex-shrink-0">
                  <Phone className="text-white" size={20} />
                </div>
                <a 
                  href={`tel:${companyInfo.phone}`}
                  className="text-gray-300 hover:text-white transition-colors text-sm"
                >
                  {companyInfo.phone}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-10 h-10 bg-[#c0932a] rounded-full flex items-center justify-center flex-shrink-0">
                  <Mail className="text-white" size={20} />
                </div>
                <a 
                  href={`mailto:${companyInfo.email}`}
                  className="text-gray-300 hover:text-white transition-colors text-sm"
                >
                  {companyInfo.email}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-300 text-sm text-center md:text-left">
              © {currentYear} {companyInfo.legalName}. All rights reserved.
            </p>
            <div className="flex gap-6 text-sm">
              <button className="text-gray-300 hover:text-white transition-colors">
                Privacy Policy
              </button>
              <button className="text-gray-300 hover:text-white transition-colors">
                Terms of Service
              </button>
              <button className="text-gray-300 hover:text-white transition-colors">
                Cookie Policy
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
